module.exports = __webpack_public_path__ + "img/help-preset.fdf9e4db.webp";